/* Avokaid: add to cart with selling plan, quantity and line item properties. */
/* Handles only [data-ajax-add] forms that contain selling_plan, quantity or properties[...] fields; other forms are left to home.js. */
(function () {
    function collectProperties(form) {
        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
            if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
            var key = el.name.slice(11, -1);
            if (key) props[key] = el.value;
        });
        return props;
    }
    function needsHandling(form) {
        return !!form.querySelector('[name="selling_plan"], [name="quantity"], [name^="properties["]');
        }
        function showError(form, msg) {
            var box = form.parentNode.querySelector('[data-cart-error]');
            if (!box) {
                box = document.createElement('p');
                box.setAttribute('data-cart-error', '');
                box.setAttribute('role', 'alert');
                box.style.color = '#c0392b';
                box.style.marginTop = '0.5rem';
                form.insertAdjacentElement('afterend', box);
            }
            box.textContent = msg || '';
            box.hidden = !msg;
        }
        document.addEventListener('submit', function (e) {
            var form = e.target;
            if (!form.matches || !form.matches('[data-ajax-add]') || !needsHandling(form)) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            var btn = e.submitter || form.querySelector('button');
            var buyNow = !!(btn && btn.hasAttribute('data-buy-now'));
            var qtyEl = form.querySelector('[name="quantity"]');
            var planEl = form.querySelector('[name="selling_plan"]:checked') || form.querySelector('select[name="selling_plan"], input[name="selling_plan"]:not([type="radio"])');
            var item = {
                id: Number(form.querySelector('[name="id"]').value),
                quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1)
            };
            if (planEl && planEl.value) item.selling_plan = Number(planEl.value);
            var props = collectProperties(form);
            if (Object.keys(props).length) item.properties = props;
            var buttons = Array.prototype.slice.call(form.querySelectorAll('button'));
            var wasDisabled = buttons.map(function (b) { return b.disabled; });
            buttons.forEach(function (b) { b.disabled = true; });
            showError(form, '');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [item] })
            }).then(function (r) {
                return r.json().then(function (data) {
                    if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
                    return data;
                });
            }).then(function () {
                if (buyNow) { window.location.href = '/checkout'; return null; }
                return fetch('/cart.js').then(function (r) { return r.json(); });
            }).then(function (cart) {
                if (!cart) return;
                document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
                document.dispatchEvent(new CustomEvent('avokaid:added'));
            }).catch(function (err) {
                showError(form, err.message); fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); });
            }).finally(function () {
                buttons.forEach(function (b, i) { b.disabled = wasDisabled[i]; });
            });
        }, true);
        function validityMsg(el) { if (!el || !el.closest || !el.setCustomValidity || !el.closest('form[data-ajax-add]')) return; el.setCustomValidity(''); if (el.validity.valid) return; if (el.name === 'quantity') { el.setCustomValidity(el.validity.valueMissing ? 'Please enter a quantity.' : 'Please enter a whole number, 1 or more.'); } else if (el.type === 'checkbox') { el.setCustomValidity('Please tick this box to continue.'); } }
        ['invalid', 'input', 'change'].forEach(function (t) { document.addEventListener(t, function (e) { validityMsg(e.target); }, true); });function syncConsent(cb) { var form = cb.closest('form'); if (!form) return; form.querySelectorAll('button[type="submit"]').forEach(function (b) { b.disabled = !cb.checked; b.style.opacity = cb.checked ? '' : '0.5'; b.style.cursor = cb.checked ? '' : 'not-allowed'; }); }document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-consent]')) syncConsent(e.target); });document.querySelectorAll('[data-consent]').forEach(syncConsent); document.addEventListener('change', function (e) { var r = e.target; if (!r.matches || !r.matches('input[name="selling_plan"][data-variant-id]')) return; var form = r.closest('form'); var idEl = form && form.querySelector('[name="id"]'); if (idEl) idEl.value = r.getAttribute('data-variant-id'); var pr = document.querySelector('[data-product-price]'); if (pr && r.getAttribute('data-price')) pr.textContent = r.getAttribute('data-price') + ' USD'; }); document.querySelectorAll('input[name="selling_plan"][data-variant-id]:checked').forEach(function (r) { r.dispatchEvent(new Event('change', { bubbles: true })); });
    })();
